import script from "./PushItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PushItem.vue?vue&type=script&setup=true&lang=js"

import "./PushItem.vue?vue&type=style&index=0&id=71616f94&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71616f94"]])

export default __exports__